export default __webpack_public_path__ + "static/media/i005vp.1fff0878.webp";